// 'use client';
// import Image from 'next/image';

// const galleryImages = [
//   '/images/event-highlights/gallery-01.webp',
//   '/images/event-highlights/gallery-02.webp',
//   '/images/event-highlights/gallery-03.webp',
//   '/images/event-highlights/gallery-04.webp',  
//   '/images/event-highlights/last-event.webp',
//   '/images/event-highlights/speaker-on.webp',
//   '/images/event-highlights/standing.webp',
//   '/images/event-highlights/mic.webp',
//   '/images/event-highlights/all-speaker.webp',
//   '/images/event-highlights/speaker-on-stage.webp',
//   '/images/event-highlights/discussion.webp',
//   '/images/event-highlights/speaker.webp',
// ];

// export default function GallerySection() {
//   return (
//     <section id='event-highlights' className="w-full px-4 py-12 bg-white">
//       {/* Heading */}
//       <h2 className="text-[28px] text-center sm:text-[36px] lg:text-[48px] font-semibold text-[#1d1d1d] leading-snug mb-8 lg:pl-24">
//         Event Highlights
//       </h2>

//       {/* Gallery Grid */}
//       <div className="max-w-[1200px] mx-auto grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 sm:gap-4">
//         {galleryImages.map((src, index) => (
//           <div
//             key={index}
//             className="relative group overflow-hidden rounded-lg"
//           >
//             <Image
//               src={src}
//               alt={`Gallery ${index + 1}`}
//               width={400}
//               height={400}
//               unoptimized
//               className="object-cover transition-transform duration-500 group-hover:scale-105"
//             />

//             {/* Gradient Overlay */}
//             <div className="absolute inset-0 group-hover:opacity-0 transition-opacity duration-500" />
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// }


'use client';
import Image from 'next/image';

const galleryImages = [
  '/images/event-highlights/gallery-01.webp',
  '/images/event-highlights/gallery-02.webp',
  '/images/event-highlights/gallery-03.webp',
  '/images/event-highlights/gallery-04.webp',  
  '/images/event-highlights/last-event.webp',
  '/images/event-highlights/speaker-on.webp',
  '/images/event-highlights/standing.webp',
  '/images/event-highlights/mic.webp',
  '/images/event-highlights/all-speaker.webp',
  '/images/event-highlights/speaker-on-stage.webp',
  '/images/event-highlights/discussion.webp',
  '/images/event-highlights/speaker.webp',
];

export default function GallerySection() {
  return (
    <section data-component-id="src/app/GallerySection.tsx:73:4" data-component-path="src/app/GallerySection.tsx" data-component-line="73" data-component-end-line="100" data-component-file="GallerySection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22event-highlights%22%2C%22className%22%3A%22w-full%20px-4%20py-12%20bg-white%22%7D" id='event-highlights' className="w-full px-4 py-12 bg-white">
      {/* Heading */}
      <h2 data-component-id="src/app/GallerySection.tsx:75:6" data-component-path="src/app/GallerySection.tsx" data-component-line="75" data-component-end-line="77" data-component-file="GallerySection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-%5B28px%5D%20text-center%20sm%3Atext-%5B36px%5D%20lg%3Atext-%5B48px%5D%20font-semibold%20text-%5B%231d1d1d%5D%20leading-snug%20mb-8%20lg%3Apl-24%22%2C%22textContent%22%3A%22Event%20Highlights%22%7D" className="text-[28px] text-center sm:text-[36px] lg:text-[48px] font-semibold text-[#1d1d1d] leading-snug mb-8 lg:pl-24">
        Event Highlights
      </h2>

      {/* Gallery Grid */}
      <div data-component-id="src/app/GallerySection.tsx:80:6" data-component-path="src/app/GallerySection.tsx" data-component-line="80" data-component-end-line="99" data-component-file="GallerySection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-%5B1200px%5D%20mx-auto%20grid%20grid-cols-2%20sm%3Agrid-cols-3%20md%3Agrid-cols-4%20gap-3%20sm%3Agap-4%22%7D" className="max-w-[1200px] mx-auto grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 sm:gap-4">
        {galleryImages.map((src, index) => (
          <div data-component-id="src/app/GallerySection.tsx:82:10" data-component-path="src/app/GallerySection.tsx" data-component-line="82" data-component-end-line="97" data-component-file="GallerySection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20group%20overflow-hidden%20rounded-lg%22%7D"
            key={index}
            className="relative group overflow-hidden rounded-lg"
          >
            <Image data-component-id="src/app/GallerySection.tsx:86:12" data-component-path="src/app/GallerySection.tsx" data-component-line="86" data-component-end-line="94" data-component-file="GallerySection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22src%22%3A%22%5Bvar%3Asrc%5D%22%2C%22className%22%3A%22w-full%20h-%5B160px%5D%20sm%3Ah-%5B200px%5D%20md%3Ah-%5B250px%5D%20lg%3Ah-%5B200px%5D%20object-cover%20object-top%20transition-transform%20duration-500%20group-hover%3Ascale-105%22%7D"
            src={src}
            alt={`Gallery ${index + 1}`}
            width={320}
            height={320}
            sizes="(max-width: 640px) 160px, (max-width: 768px) 200px, (max-width: 1024px) 250px, 300px"
            unoptimized
            className="w-full h-[160px] sm:h-[200px] md:h-[250px] lg:h-[200px] object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
            {/* Gradient Overlay */}
            <div data-component-id="src/app/GallerySection.tsx:96:12" data-component-path="src/app/GallerySection.tsx" data-component-line="96" data-component-end-line="96" data-component-file="GallerySection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20bg-gradient-to-t%20from-black%2F60%20via-transparent%20to-transparent%20group-hover%3Aopacity-0%20transition-opacity%20duration-500%22%7D" className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent group-hover:opacity-0 transition-opacity duration-500" />
          </div>
        ))}
      </div>
    </section>
  );
}